/**
 * Alignements proposal (positions horizontal / vertical) → flex CSS.
 */

export function normalizeHorizontalAlign(value, fallback = 'left') {
  const h = String(value ?? fallback).toLowerCase();
  if (h === 'start' || h === 'left') return 'start';
  if (h === 'end' || h === 'right') return 'end';
  if (h === 'center' || h === 'middle') return 'center';
  return fallback === 'end' ? 'end' : fallback === 'center' ? 'center' : 'start';
}

export function normalizeVerticalAlign(value, fallback = 'center') {
  const v = String(value ?? fallback).toLowerCase();
  if (v === 'start' || v === 'top') return 'start';
  if (v === 'end' || v === 'bottom') return 'end';
  if (v === 'center' || v === 'middle') return 'center';
  if (v === 'stretch') return 'stretch';
  return fallback === 'start' ? 'start' : fallback === 'end' ? 'end' : 'center';
}

/** horizontal proposal → text-align CSS */
export function horizontalToTextAlign(value, fallback = 'left') {
  const raw = String(value ?? fallback).toLowerCase();
  if (raw === 'justify') return 'justify';
  if (raw === 'start' || raw === 'left') return 'left';
  if (raw === 'end' || raw === 'right') return 'right';
  if (raw === 'center' || raw === 'middle') return 'center';
  return fallback;
}

/**
 * Positions box prioritaire, sinon style texte (configuration.textStyles).
 */
export function resolveBoxPositions(box, stylePositions) {
  return {
    horizontal: box?.positions?.horizontal ?? stylePositions?.horizontal ?? 'left',
    vertical: box?.positions?.vertical ?? stylePositions?.vertical ?? 'center',
  };
}

export function flexClasses(horizontal, vertical) {
  return {
    h: normalizeHorizontalAlign(horizontal),
    v: normalizeVerticalAlign(vertical),
  };
}
